import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/lib/supabase";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const SubscriptionCheck = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const { data: tokens, isLoading } = useQuery({
    queryKey: ["subscription-tokens", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("subscription_tokens")
        .select("*")
        .eq("user_id", user?.id)
        .eq("is_used", false);
      
      if (error) throw error;
      return data;
    },
    enabled: !!user
  });

  if (isLoading) return null;

  if (!tokens?.length) {
    return (
      <Alert className="mb-6 bg-flux-cyan/10 border-flux-cyan/20">
        <AlertCircle className="h-4 w-4 text-flux-cyan" />
        <AlertDescription className="text-sm text-gray-300">
          You need a subscription token to create a startup. 
          <Button 
            variant="link" 
            className="text-flux-cyan p-0 ml-2"
            onClick={() => navigate("/vesu-ai/start")}
          >
            Get one with VesuStart
          </Button>
        </AlertDescription>
      </Alert>
    );
  }

  return null;
};